import * as React from 'react'
import { sbEditable } from '@storyblok/storyblok-editable'
import { GlossaryListProps } from './types'
import { Styled } from './styled'
import { useGlossaryGroups } from './hooks'
import { Group } from './components/Group'

export const GlossaryList = ({ blok }: GlossaryListProps) => {
  const { glossaryItem } = blok
  const groups = useGlossaryGroups(glossaryItem)

  return (
    <Styled.Container {...sbEditable(blok)}>
      {groups.map(group => (
        <Group group={group} groups={groups} key={group.id} />
      ))}
    </Styled.Container>
  )
}
